import Vue from "vue";


Vue.config.API_URL = "";
Vue.config.IMAGE_URL = "";
Vue.config.USER_AGREMENT="";
Vue.config.LOGO_WORDS=[];
Vue.config.BASE_URL = "";
Vue.config.BASE_URL_FRONT="";
Vue.config.JS_SCRIPT="";
Vue.config.TG_BOT = "";
Vue.config.URL_LOGOTYPE=null;
Vue.config.MATRIX_AUTH_ENABLE=false;
Vue.config.MATRIX_BOT='@asdasdasdasd';
Vue.config.AUTH_REQUIRED=0;
Vue.config.DISABLE_NOTIFY_TYPES=0;
Vue.config.MAIN_DAY_COLOR="#FF9200";
Vue.config.MAIN_NIGHT_COLOR="#0dda4d";
// Vue.config.currencys=["MENA"];
// Vue.config.currencys_title={"MENA":"MENA"};
// Vue.config.currencys_chart=[
//     {
//         label: 'MENA',
//         backgroundColor: ['#03acca', '#ff3709'],
//         data: [0, 0]
//     }
//
// ];


// Vue.config.currencys=["RUB"];
// Vue.config.currencys_title={"RUB":"₽"};

// Vue.config.currencys_chart=[
//     {
//         label: '₽',
//         backgroundColor: ['#03acca', '#ff3709'],
//         data: [0, 0]
//     }
//
// ];




